var CulinaryBingMap = CulinaryBingMap || {};
CulinaryBingMap.Map = function () {

	//VARIABLES
	var _log = false,
		//imgBaseUrl = '', //"http://www.travelwisconsin.com",
		baseCategory = '', //populated below
		basePath = decodeURIComponent($("[data-basepath]").data("basepath")),

		breakPoints = {
			'main': 992 //760
		},
		isMobile = false, //mobile/desktop only, 760px brkpt
		wasMobile = null,
		isTouch = $('html').hasClass('touch') ? true : false,
		isDisableZoom = isTouch,//pinch/mousewheel/zoom

		//general/config
		map = null,
		overlay = '',
		reportType = "culinary",
		baseZoom = 7,
		mobileZoom = 6,
		useZoom = null,
		lastZoomLevel = 0,
		mobileDisableZooming = false,
		desktopDisableZooming = true,
		lastCenterLocation = null,
		useCenterLocation = null,
		useMinZoom = null,
		useDisableZooming = null,
		infobox = null,
		reportInfoBoxArray = Array(),
		toMapReset,//timeout
		toMapResetMS = 30,
		isZoomingToPin = false,
		isClusteringLoaded = false,
		wisconsinMask = null,
		isPushpinActive = false,

		dataHold = null,
		noEpisodeData = null,
		episodeData = null,

		colorPinSingle = '#000000',
		colorPinCluster = '#FFC40C',//'#333333',

		//layers
		clusterLayer = null,

		//location
		desktopCenter = null,
		tabletLandscapeCenter = null,
		tabletPortraitCenter = null,
		mobileCenter = null,
		centerLocation = null,
		wiBoundsOuter = null,//used for zoom-out-max
		wiBounds = null //used to place svg directly over WI
		;

	if(_log)console.log('isTouch:', isTouch);


	//TEMPLATES
	var reportsAllBodySSTemplate = $('#reportsAllBodySSTemplate').html(),
		noReportsTemplate = $('#noReportsTemplate').html(),
		preloaderMapTemplate = $('#preloaderMapTemplate').html(),
		pinInfoboxSSTemplate = $('#pinInfoboxSSTemplate').html(),
		//Can't append a non-closed tag
		reportsOLOpenTemplate = '<div class="js-region-list d-flex flex-lg-column">',
		reportsOLCloseTemplate = '</div>';

	//MAP OPTIONS
	var mapOptions = {
		zoom: baseZoom,
		center: centerLocation,
		enableSearchLogo: false,
		showScalebar: false,
		showDashboard: false,
		useInertia: false,
		disableKeyboardInput: true,
		disablePanning: false, //mobile.matches, // - remove all panning for MOBILE ONLY except when using the compass buttons
		liteMode: true
	};

	/**
	 * Get if map is initialized yet
	 */
	var getMapInit = function () {
		return map;
	}

	/**
	 * Initialize Buttons
	 */
	var initializeButtons = function () {
		// if (_log) console.group('BingMap.Map.initializeButtons()');
		//Map Controls
		$('#zoomIn').on('click', function () {
			zoomMap('+');
		});
		$('#zoomOut').click('click', function () {
			zoomMap('-');
		});
		$('#resetMap').click('click', function () {
			softResetMap();
			tw.CulinaryShow.resetAllPanes();
		});		
	}

	/**
	 * (RE)initializeMap Microsoft map functionality AFTER bing maps library is loaded, will be triggered via callback > index.js > map.js
	 */
	var initializeMap = function (config) {
		// if (_log) console.group('BingMap.Map.initializeMap()', config);
		// if (_log) console.log('config:', config);

		//console.log("$('.js-preloader.map').width()" + $('.js-preloader.map').width());
		if ($('.js-preloader').length === 0) {
			addPreloaderMap();
		}

		reportInfoBoxArray = [];

		desktopCenter = new Microsoft.Maps.Location(45.205852, -89.83011); //(YY, XX)//45.205852, -92.03011
		tabletLandscapeCenter = new Microsoft.Maps.Location(45.205852, -89.83011);
		tabletPortraitCenter = new Microsoft.Maps.Location(44.73739, -88.8);
		mobileCenter = new Microsoft.Maps.Location(44.93282, -89.800); //44.80282, -90.07542

		reportType = config.ReportType;
		baseCategory = 'Culinary Show';

		if (_log) console.log('reportType:', reportType);
		if (_log) console.log('baseCategory:', baseCategory);

		//(TL:YY, TL:XX, BR:YY, BR:XX)
		wiBoundsOuter = Microsoft.Maps.LocationRect.fromEdges(53.882830, -104.858254, 37.131071, -75.932511);
		wiBounds = Microsoft.Maps.LocationRect.fromEdges(47.089442, -92.897646, 42.474545, -86.802900);

		trackResize(); //get initial window dims, set presets

		//https://docs.microsoft.com/en-us/bingmaps/v8-web-control/map-control-api/maptypeid-enumeration
		mapOptions = {
			mapTypeId: Microsoft.Maps.MapTypeId.grayscale, //aerial,//grayscale//canvasLight//road//mercator
			maxBounds: wiBoundsOuter,
			maxZoom: 18,
			minZoom: useMinZoom,
			zoom: useZoom, //baseZoom,
			center: useCenterLocation, //centerLocation,
			disableZooming: useDisableZooming,
			enableSearchLogo: false,
			showScalebar: false,
			showDashboard: false,
			useInertia: false,
			disableKeyboardInput: true,
			disablePanning: false, //mobile.matches, // - remove all panning for MOBILE ONLY except when using the compass buttons
			liteMode: true,
			allowHidingLabelsOfRoad: true,
		};
		if (_log) console.log('mapOptions:', mapOptions);

		map = new Microsoft.Maps.Map('#map', mapOptions);
		map.entities.clear();

		//Load the Clustering module.
		Microsoft.Maps.loadModule("Microsoft.Maps.Clustering", function () {
			if (_log) console.log('Microsoft.Maps.Clustering');
			isClusteringLoaded = true;
		});

		// loadTopoTiles();

		addGroundOverlay();

		lastZoomLevel = map.getZoom();
		lastCenterLocation = map.getCenter();
		Microsoft.Maps.Events.addHandler(map, 'viewchangeend', viewChanged);
		// Microsoft.Maps.Events.addHandler(map, 'click', function (e) { 
		// 	alert('mapClick'); 
		// 	//moveToMapClick(e);
		// });
		
		//unload preloader
		$('.js-preloader').remove();
	}

	/**
	 * Add custom ground overlay
	 */
	var addGroundOverlay = function () {
		overlay = new Microsoft.Maps.GroundOverlay({
            bounds: wiBounds,
			imageUrl: '/images/public/map_images/culinary-map-wisconsin.svg',
            // opacity: 0.5,
            rotation: 0
        });
        map.layers.insert(overlay);
	}

	/**
	 * Map handler, watch for view port changes
	 * @param {*} e 
	 */
	var viewChanged = function (e) {
		clearTimeout(toMapReset);
		toMapReset = setTimeout(function(){ 
			var didChange = false;

			//console.log("clusterLayer.getVisible();", clusterLayer.getVisible());
			
			if (lastZoomLevel != map.getZoom()) {
				didChange = true;
				lastZoomLevel = map.getZoom();
				if (_log) console.log("viewChanged...lastZoomLevel", lastZoomLevel);
				map.setView({zoom: map.getZoom()});

			}
			if (lastCenterLocation != map.getCenter()) {
				didChange = true;
				lastCenterLocation = map.getCenter();
				if (_log) console.log("viewChanged...lastCenterLocation", lastCenterLocation);
			}
			// //CLEAR OUT DETAILS: if NOT auto-zooming-into-pin, AND view-did-change AND reportsall is-hidden
			// if (!isZoomingToPin && didChange && $('.js-reports').hasClass('is-hidden')) {
			// 	tw.CulinaryShowsListings.clearDetailsShowAll();
			// }
		}, toMapResetMS);
	}//toMapReset

	/**
	 * Allow index.js to update reporttype here
	 */
	var updateReportType = function (type) {
		reportType = type;
		//if (_log) console.log('updateReportType.reportType:', reportType);
	}

	var getReportType = function () {
		return reportType;
	}

	var getNoEpisodeData = function (data) {
		if (noEpisodeData == null) {
			noEpisodeData = data;
		}
	}
	var getEpisodeData = function (data) {
		if (episodeData == null) {
			episodeData = data;
		}
	}
	/**
	 * Add Preloader Map template
	 * LOAD MAP PRELOADER IMMEDIATELY on initial load as soon as the file is ready
	 */
	var addPreloaderMap = function () {
		if (_log) console.log('addPreloaderMap()');
		var compiledTemplate = Template7.compile(preloaderMapTemplate),
			htmlPreloader = compiledTemplate();
		$('#map').html(htmlPreloader);
	}
	addPreloaderMap();

	/**
	 * Toggle pushpins
	 * @param {*} isChecked
	 * @param {*} toggleValue
	 */	
	var togglePushpinCluster = function (isChecked, toggleValue) {
		var tempData = [];

		if (isChecked) {
			if (toggleValue === 'culinary-gem') {
				for (var i = 0; i < noEpisodeData.length; i++) {
					if(noEpisodeData[i].IsCulinaryGem) {
						tempData.push(noEpisodeData[i]);
						dataHold = tempData;
					}
				}				
			} else if (toggleValue === 'judge-favorite') {
				for (var i = 0; i < noEpisodeData.length; i++) {
					if(noEpisodeData[i].IsJudgeFavorite) {
						tempData.push(noEpisodeData[i]);
						dataHold = tempData;
					}
				}					
			} else if (toggleValue === 'episode-features') {
				dataHold = episodeData;
				tempData = dataHold;
			}
		} else {
			tempData = dataHold;
		}
		addPushpinCluster(tempData);
	}


	/**
	 * Add pushpin clusters to layer
	 * https://docs.microsoft.com/en-us/bingmaps/v8-web-control/map-control-concepts/clustering-module-examples/clusters-with-a-list-and-linking
	 * @param {*} data 
	 */
	var addPushpinCluster = function (data) {
		if (_log) console.log('addPushpinCluster()', data);

		for (var i = 0; i < data.length; i++) {
			if (data[i].CulinaryEpisode && data[i].CulinaryEpisode.EpisodeNumber) {
				data[i].EpisodeNumber = data[i].CulinaryEpisode.EpisodeNumber;
			}
		}

		if (dataHold == null) {
			dataHold = data;
		}
		if (clusterLayer != null) {
			clusterLayer.clear();
		}
		var intIsMapReady = setInterval(function () {
			//if (_log) console.log('addPushpinCluster().intIsMapReady');
			if (map != null && isClusteringLoaded) {
				clearInterval(intIsMapReady);
				//Add an infobox to the map.
				infobox = new Microsoft.Maps.Infobox(map.getCenter(), {
					visible: false
				});
				infobox.setMap(map);
				clusterLayer = new Microsoft.Maps.ClusterLayer(createCustomPushpins(data), {
					clusteredPinCallback: createCustomClusterPushpins,
					callback: createPushpinList,
					visible: true,
					setZIndex: 99999,
					gridSize: 48
				});
				if (_log) console.log('clusterLayer', clusterLayer);
				Microsoft.Maps.Events.addHandler(clusterLayer, 'click', function(e) {
					var pinType = (e.target instanceof Microsoft.Maps.ClusterPushpin) ? 'Cluster': 'Pushpin';
					//if (_log) console.log('------------- Clicked ', pinType, ': ', e.target);
					//alert('clusterLayer click4');
				});
				map.layers.insert(clusterLayer);
			}
		}, 200);
	}
	/**
	 * Create custom pushpins, inject extra datapoints
	 * @param {*} data 
	 */
	var createCustomPushpins = function (data) {
		var pins = [];
		for (var i = 0; i < data.length; i++) {
			var episodeNumber = data[i].EpisodeNumber !== undefined ? data[i].EpisodeNumber : (parseInt(i) + 1);
			var svg = ['<svg width="84" height="96" viewBox="0 0 84 96" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1311_1246)"><path d="M39.527 56.2405C34.6449 50.1378 23.7539 35.5853 23.7539 27.3232C23.7539 17.3711 31.7343 9.29675 41.7803 9.29675C51.7324 9.29675 59.8067 17.3711 59.8067 27.3232C59.8067 35.5853 48.8219 50.1378 43.9397 56.2405C42.8131 57.6488 40.6537 57.6488 39.527 56.2405Z" fill="#FFC40C"/><path d="M22.8558 27.3232C22.8558 29.5634 23.5881 32.151 24.7035 34.8156C25.8248 37.4945 27.3637 40.3217 29.0441 43.0612C32.4052 48.5407 36.3745 53.7375 38.8257 56.8015C40.3119 58.6593 43.1548 58.6593 44.641 56.8015C47.0908 53.7393 51.0835 48.5428 54.4681 43.0636C56.1602 40.3242 57.7111 37.497 58.8415 34.818C59.9658 32.1534 60.7048 29.5648 60.7048 27.3232C60.7048 16.8751 52.2284 8.39867 41.7803 8.39867C31.2353 8.39867 22.8558 16.8781 22.8558 27.3232Z" stroke="white" stroke-width="1.79616"/>',
			'<text x="50%" y="35%" dominant-baseline="middle" text-anchor="middle" fill="black" font-size="24" font-weight="bold" font-family= "Grold Rounded Slim,Helvetica,Arial,sans-serif" class="font-weight-bolder">' + episodeNumber + '</text>',
			'</g><defs><filter id="filter0_d_1311_1246" x="0.403065" y="0.315939" width="82.7544" height="94.7002" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="14.3693"/><feGaussianBlur stdDeviation="10.777"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1311_1246"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1311_1246" result="shape"/></filter></defs></svg>'];

			var pushpinOptions = {
				icon: svg.join(''),
				anchor: new Microsoft.Maps.Point(42, 48),
			};

			var pinLocation = new Microsoft.Maps.Location(data[i].Latitude, data[i].Longitude);
			var pushpin = new Microsoft.Maps.Pushpin(pinLocation, pushpinOptions);
			
			//inject extra datapoints into pushpin
			pushpin.index = i;
			pushpin.ID = data[i].ID;
			pushpin.Title = data[i].Title;
			pushpin.Description = data[i].Description;
			pushpin.Url = data[i].Url;
			pushpin.City = data[i].City;
			pushpin.State = data[i].State;
			pushpin.PlaceImage = data[i].PlaceImage;
			pushpin.PlaceAttribute1 = data[i].PlaceAttribute1;
			pushpin.PlaceAttribute2 = data[i].PlaceAttribute2;
			pushpin.PlaceAttribute3 = data[i].PlaceAttribute3;		
			pushpin.Latitude = data[i].Latitude;
			pushpin.Longitude = data[i].Longitude;
			pushpin.IsCulinaryGem = data[i].IsCulinaryGem;
			pushpin.IsJudgeFavorite = data[i].IsJudgeFavorite;
			pushpin.Articles = data[i].Articles;
			pushpin.CulinaryEpisode = data[i].CulinaryEpisode;
			pushpin.EpisodeNumber = data[i].EpisodeNumber
			
			pins.push(pushpin);

			Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', mouseHandler);
			Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', mouseHandler);
			Microsoft.Maps.Events.addHandler(pins[i], 'click', pushpinClicked);
			//if (_log) console.log('addHandler.pushpinClicked.i', i);
		}

		return pins;
	}

	
	/**
	 * Create custom pushpin clusters
	 * @param {*} cluster 
	 */
	var createCustomClusterPushpins = function (cluster) {
		var minRadius = 12;
		var outlineWidth = 7;
		var fillColor = colorPinCluster;
		
		// Get the number of pushpins in the cluster
		var clusterSize = cluster.containedPushpins.length;
		// Calculate the radius of the cluster based on the number of pushpins in the cluster, using a logarithmic scale.
		var radius = Math.log(clusterSize) / Math.log(10) * 12 + minRadius;
		var text = clusterSize.toString();
		//Create an SVG string of two circles, one on top of the other, with the specified radius and color.
		var svg = ['<svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.650391" width="65.1934" height="65.1934" rx="32.5967" fill="#FFC40C" fill-opacity="0.4"/><rect x="9.24609" y="8.59668" width="48" height="48" rx="24" fill="#FFC40C"/>',
		'<text x="50%" y="52%" dominant-baseline="middle" text-anchor="middle" fill="black" font-size="28" font-weight="bold" font-family="Grold Rounded Slim,Helvetica,Arial,sans-serif" class="font-weight-bolder">' + text + '</text>',
		'</svg>'];
		cluster.setOptions({
			icon: svg.join(''),
			anchor: new Microsoft.Maps.Point(33, 33),
			text: ''
		});

		//Add handler for the cluster click event.
		Microsoft.Maps.Events.addHandler(cluster, 'click', clusterClicked); //pushpinClicked
		//if (_log) console.log('addHandler.clusterClicked.cluster', cluster);
	}

	/**
	 * Cluster clicked action
	 * @param {*} e 
	 */
	var clusterClicked = function (e) {
		if (_log) console.log('clusterClicked:', e);
		if (e.target.containedPushpins) {
			var locs = [];
			for (var i = 0, len = e.target.containedPushpins.length; i < len; i++) {
				//Get the location of each pushpin.
				locs.push(e.target.containedPushpins[i].getLocation());
			}

			//Create a bounding box for the pushpins.
			var bounds = Microsoft.Maps.LocationRect.fromLocations(locs);

			//Zoom into the bounding box of the cluster. 
			//Add a padding to compensate for the pixel area of the pushpins.
			map.setView({
				bounds: bounds,
				padding: 100
			});
			tw.Analytics.ga4(baseCategory, 'Map Cluster Click', '');
		}
	}

	/**
	 * Pushpin clicked action
	 * @param {*} e 
	 */
	var pushpinClicked = function (e) {
		if (_log) console.log('pushpinClicked()e:', e);
		isPushpinActive = true;
		var episodeNumber = e.target.EpisodeNumber !== undefined ? e.target.EpisodeNumber : (parseInt(e.target.index) + 1);
		var activeSVG = ['<svg width="84" height="96" viewBox="0 0 84 96" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1311_1246)"><path d="M39.527 56.2405C34.6449 50.1378 23.7539 35.5853 23.7539 27.3232C23.7539 17.3711 31.7343 9.29675 41.7803 9.29675C51.7324 9.29675 59.8067 17.3711 59.8067 27.3232C59.8067 35.5853 48.8219 50.1378 43.9397 56.2405C42.8131 57.6488 40.6537 57.6488 39.527 56.2405Z" fill="#EF6F1A"/><path d="M22.8558 27.3232C22.8558 29.5634 23.5881 32.151 24.7035 34.8156C25.8248 37.4945 27.3637 40.3217 29.0441 43.0612C32.4052 48.5407 36.3745 53.7375 38.8257 56.8015C40.3119 58.6593 43.1548 58.6593 44.641 56.8015C47.0908 53.7393 51.0835 48.5428 54.4681 43.0636C56.1602 40.3242 57.7111 37.497 58.8415 34.818C59.9658 32.1534 60.7048 29.5648 60.7048 27.3232C60.7048 16.8751 52.2284 8.39867 41.7803 8.39867C31.2353 8.39867 22.8558 16.8781 22.8558 27.3232Z" stroke="white" stroke-width="1.79616"/>',
		'<text x="50%" y="35%" dominant-baseline="middle" text-anchor="middle" fill="black" font-size="24" font-weight="bold" font-family= "Grold Rounded Slim,Helvetica,Arial,sans-serif" class="font-weight-bolder">' + episodeNumber + '</text>',
		'</g><defs><filter id="filter0_d_1311_1246" x="0.403065" y="0.315939" width="82.7544" height="94.7002" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="14.3693"/><feGaussianBlur stdDeviation="10.777"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1311_1246"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1311_1246" result="shape"/></filter></defs></svg>'];

		if (isPushpinActive) {
			e.target.setOptions(
				{ icon: activeSVG.join('') }
			);
		}
		tw.Analytics.ga4(baseCategory, 'Map Marker Click', e.target.Title);
		tw.CulinaryShowsListings.getReportDetails(e.target.ID, e.target.index, e.target.EpisodeNumber);
	}

	/**
	 * Pushpin clicked action
	 * @param {*} e 
	 */
	var pushpinMouseover = function (e) {
		var episodeNumber = e.target.EpisodeNumber !== undefined ? e.target.EpisodeNumber : (parseInt(e.target.index) + 1);
		var activeSVG = ['<svg width="84" height="96" viewBox="0 0 84 96" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1311_1246)"><path d="M39.527 56.2405C34.6449 50.1378 23.7539 35.5853 23.7539 27.3232C23.7539 17.3711 31.7343 9.29675 41.7803 9.29675C51.7324 9.29675 59.8067 17.3711 59.8067 27.3232C59.8067 35.5853 48.8219 50.1378 43.9397 56.2405C42.8131 57.6488 40.6537 57.6488 39.527 56.2405Z" fill="#EF6F1A"/><path d="M22.8558 27.3232C22.8558 29.5634 23.5881 32.151 24.7035 34.8156C25.8248 37.4945 27.3637 40.3217 29.0441 43.0612C32.4052 48.5407 36.3745 53.7375 38.8257 56.8015C40.3119 58.6593 43.1548 58.6593 44.641 56.8015C47.0908 53.7393 51.0835 48.5428 54.4681 43.0636C56.1602 40.3242 57.7111 37.497 58.8415 34.818C59.9658 32.1534 60.7048 29.5648 60.7048 27.3232C60.7048 16.8751 52.2284 8.39867 41.7803 8.39867C31.2353 8.39867 22.8558 16.8781 22.8558 27.3232Z" stroke="white" stroke-width="1.79616"/>',
		'<text x="50%" y="35%" dominant-baseline="middle" text-anchor="middle" fill="black" font-size="24" font-weight="bold" font-family= "Grold Rounded Slim,Helvetica,Arial,sans-serif" class="font-weight-bolder">' + episodeNumber + '</text>',
		'</g><defs><filter id="filter0_d_1311_1246" x="0.403065" y="0.315939" width="82.7544" height="94.7002" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="14.3693"/><feGaussianBlur stdDeviation="10.777"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1311_1246"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1311_1246" result="shape"/></filter></defs></svg>'];
		if (!isPushpinActive) {
			e.target.setOptions(
				{ icon: activeSVG.join('') }
			);
			showInfobox(e.target);
		}
	}

	var pushPinMouseout = function (e) {
		var episodeNumber = e.target.EpisodeNumber !== undefined ? e.target.EpisodeNumber : (parseInt(e.target.index) + 1);
		var svg = ['<svg width="84" height="96" viewBox="0 0 84 96" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1311_1246)"><path d="M39.527 56.2405C34.6449 50.1378 23.7539 35.5853 23.7539 27.3232C23.7539 17.3711 31.7343 9.29675 41.7803 9.29675C51.7324 9.29675 59.8067 17.3711 59.8067 27.3232C59.8067 35.5853 48.8219 50.1378 43.9397 56.2405C42.8131 57.6488 40.6537 57.6488 39.527 56.2405Z" fill="#FFC40C"/><path d="M22.8558 27.3232C22.8558 29.5634 23.5881 32.151 24.7035 34.8156C25.8248 37.4945 27.3637 40.3217 29.0441 43.0612C32.4052 48.5407 36.3745 53.7375 38.8257 56.8015C40.3119 58.6593 43.1548 58.6593 44.641 56.8015C47.0908 53.7393 51.0835 48.5428 54.4681 43.0636C56.1602 40.3242 57.7111 37.497 58.8415 34.818C59.9658 32.1534 60.7048 29.5648 60.7048 27.3232C60.7048 16.8751 52.2284 8.39867 41.7803 8.39867C31.2353 8.39867 22.8558 16.8781 22.8558 27.3232Z" stroke="white" stroke-width="1.79616"/>',
		'<text x="50%" y="35%" dominant-baseline="middle" text-anchor="middle" fill="black" font-size="24" font-weight="bold" font-family= "Grold Rounded Slim,Helvetica,Arial,sans-serif" class="font-weight-bolder">' + episodeNumber + '</text>',
		'</g><defs><filter id="filter0_d_1311_1246" x="0.403065" y="0.315939" width="82.7544" height="94.7002" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="14.3693"/><feGaussianBlur stdDeviation="10.777"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1311_1246"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1311_1246" result="shape"/></filter></defs></svg>'];

		if (!isPushpinActive) { 
			e.target.setOptions(
				{ icon: svg.join('') }
			);
			deleteReportInfoBoxes(e.target);
		}
	}

	/**
	 * Show infobox by grid key (what's in view pane)
	 * @param {*} gridKey 
	 */
	var showInfoboxByGridKey = function (gridKey) {
		if (_log) console.log('showInfoboxByGridKey:', gridKey);
		//Look up the cluster or pushpin by gridKey.
		var clusterPin = clusterLayer.getClusterPushpinByGridKey(gridKey);

		//Show an infobox for the cluster or pushpin.
		showInfobox(clusterPin);
	}

	/**
	 * Show infobox
	 */
	var showInfobox = function (pinData) {
		if (_log) console.log('showInfobox:', pinData);

		var infoboxOptions = {
			width: 100,
			height: 100,
			zIndex: 1,
			id: pinData.Title,
			offset: new Microsoft.Maps.Point(-175, 65)
		};
		var pinLocation = new Microsoft.Maps.Location(pinData.Latitude, pinData.Longitude);
		var pinInfobox = new Microsoft.Maps.Infobox(pinLocation, infoboxOptions);
		var compiledTemplate = Template7.compile(pinInfoboxSSTemplate);
		var jsonContent = {
			ID: pinData.ID,
			Title: pinData.Title,
			City: pinData.City,
			State: pinData.State,
			PlaceImage: pinData.PlaceImage,
			PlaceAttribute1: pinData.PlaceAttribute1,
			PlaceAttribute2: pinData.PlaceAttribute2,
			PlaceAttribute3: pinData.PlaceAttribute3
		};
		var htmlInfobox = compiledTemplate(jsonContent);
		pinInfobox.setHtmlContent(htmlInfobox);
		pinInfobox.setMap(map);
		reportInfoBoxArray.push(pinInfobox);
	}

	/**
	 * Create pushpin list, keep updated based on what is in view pane
	 */
	var createPushpinList = function () {
		if (_log) console.log('createPushpinList()');
		//Create a list of displayed pushpins each time clustering layer updates.
		if (clusterLayer != null) {
			infobox.setOptions({
				visible: false
			});
			//Get all pushpins that are currently displayed.
			var tempData = clusterLayer.getDisplayedPushpins();
			var data = tempData;

			if (_log) console.log('clusterLayer.getDisplayedPushpins():', data);

			for (var i = 0; i < data.length; i++) {
				if (data[i].CulinaryEpisode && data[i].CulinaryEpisode.EpisodeNumber) {
					data[i].EpisodeNumber = data[i].CulinaryEpisode.EpisodeNumber;
				}
			}

			for (var i = 0; i < data.length; i++) {
				data[i].ItemIndex = data[i].index;
			}			

			// Sort by Index if no EpisodeNumber
			if (data.some(item => item.EpisodeNumber !== undefined)) {
				data.sort((a, b) => a.EpisodeNumber - b.EpisodeNumber);
			} else {
				data.sort((a, b) => a.index - b.index);
			}

			$('#reportsAll').html('');
			deleteReportInfoBoxes();

			var htmlBody = reportsOLOpenTemplate;
      		if (data.length > 0) {
				var compiledTemplateBody = Template7.compile(reportsAllBodySSTemplate);
				for (var i = 0; i < data.length; i++) {
					var jsonContentBody = {
						index: i,
						ID: data[i].ID,
						Title: data[i].Title,
						Index: data[i].Index,
						Description: data[i].Description,
						Url: data[i].Url,
						City: data[i].City,
						State: data[i].State,
						PlaceImage: data[i].PlaceImage,
						PlaceAttribute1: data[i].PlaceAttribute1,
						PlaceAttribute2: data[i].PlaceAttribute2,
						PlaceAttribute3: data[i].PlaceAttribute3,
						Latitude: data[i].Latitude,
						Longitude: data[i].Longitude,
						IsCulinaryGem: data[i].IsCulinaryGem,
						IsJudgeFavorite: data[i].IsJudgeFavorite,
						Articles: data[i].Articles,
						CulinaryEpisode: data[i].CulinaryEpisode,
						EpisodeNumber: data[i].EpisodeNumber,
						ItemIndex: data[i].ItemIndex
					};
					htmlBody += compiledTemplateBody(jsonContentBody);		
				}
			} else {
				//htmlBody += '<div>no reports found</div>';
				var compiledTemplateBody = Template7.compile(noReportsTemplate);
				htmlBody += compiledTemplateBody();
			}
			//ADD REGION FOOTER, OL CLOSING TAG
			htmlBody += reportsOLCloseTemplate;
			//if (_log) console.log('htmlBody:', htmlBody);
			$('#reportsAll').append(htmlBody);
			
			
			if (dataHold.length == data.length) {
				$('.js-see-all').addClass('hidden');	
			}
			else {
				if (data.length > 0) {
					var seeAllBoxClone = $('.js-see-all').clone().removeClass('hidden');
					$('.js-region-list').append(seeAllBoxClone);					
				} else {
					$('.js-see-all').addClass('hidden');
				}
			}
			

			var slickInitialized = false;
	
			function initSlick() {
				$('.js-region-list').slick({
					infinite: false,
					slidesToShow: 1.15,
					slidesToScroll: 1,
					variableWidth: false,
					prevArrow: $('.js-culinary-card-prev'),
					nextArrow: $('.js-culinary-card-next')
				});
				slickInitialized = true;
				$('.js-culinary-card-buttons').addClass('d-sm-flex');
				$('.js-culinary-card-buttons').removeClass('d-sm-none');
				updateSlick();
			}	
			function destroySlick() {
				if (slickInitialized) {
					$('.js-region-list').slick('unslick');
					slickInitialized = false;
					
					$('.js-culinary-card-buttons').removeClass('d-sm-flex');
					$('.js-culinary-card-buttons').addClass('d-sm-none');
				}
			}

			function updateSlick() {
				var numSlides = $('.js-region-list .slick-slide').length;
		
				if (numSlides > 1) {
					if (!slickInitialized) {
						initSlick();
					} else {
						$('.js-region-list').slick('refresh');
					}
				} else {
					destroySlick();
				}
			}
			updateSlick();
				
			if (isMobile) {
				initSlick();
			} else {
				if (isTouch) {
					initSlick();
				} else {
					destroySlick();
				}
			}

		}
	}


	var deleteReportInfoBoxes = function () {
		// if (_log) console.log('deleteReportInfoBoxes()');
		// if (_log) console.log('reportInfoBoxArray.before..', reportInfoBoxArray);
		for (var i = 0; i < reportInfoBoxArray.length; i++) {
			//console.log(i, reportInfoBoxArray[i]);
			reportInfoBoxArray[i].setMap(null);
			//console.log('cleared');
		}

		reportInfoBoxArray = [];
		//if (_log) console.log('reportInfoBoxArray.clearout', reportInfoBoxArray);
	}



	/**
	 * Zoom in on pin after details load
	 * @param {*} data 
	 */
	var zoomToPin = function(data){
		//if (_log) console.log('zoomToPin:', data.Latitude, data.Longitude);
		isZoomingToPin = true;
		var pinLocation = new Microsoft.Maps.Location(data.Latitude, data.Longitude);

		map.setView({
			zoom: 17,
			center: pinLocation
		});

		setTimeout(function(){ 
			isZoomingToPin = false;
			showInfobox(data);
		}, toMapResetMS * 2);

	}

	var moveToMapClick = function (e) {
		if (_log) console.log('moveToMapClick:', e);
		if (e.targetType == "map") {
			var point = new Microsoft.Maps.Point(e.getX(), e.getY());
			var loc = e.target.tryPixelToLocation(point);
			var mapLocation = new Microsoft.Maps.Location(loc.latitude, loc.longitude);
			map.setView({
				center: mapLocation
			});
		}

	}

	/**
	 * Handle mouse actions
	 * @param {*} e 
	 */
	var mouseHandler = function (e) {
		if (_log) console.group('mouseHandler()', e);

		if (e.eventName == "mouseover") {
			pushpinMouseover(e);
		} else if (e.eventName == "mouseout") {
			pushPinMouseout(e);
		}
		if (_log) console.groupEnd();
	};

	/**
	 * Soft reset map.
	 * for use when map is centered/zoomed on local reports, zoom out to initial state and clear infoxboxes and cetering ring.
	 */
	var softResetMap = function () {
		if (_log) console.group('softResetMap()');
		isPushpinActive = false;

		map.setView({
			zoom: useZoom,
			center: useCenterLocation,
			minZoom: useMinZoom,
			disableZooming: useDisableZooming
		});

		if (_log) console.groupEnd();
	}


	/**
	 * Zoom Map
	 * @param {*} direction 
	 * @param {*} location 
	 */
	var zoomMap = function (direction, location) {
		if (_log) console.log('zoomMap():', direction, location);

		if (direction === '+') {
			var newZoom = map.getZoom() + 1;
			map.setView({
				zoom: newZoom,
				center: location
			});
		} else if (direction === '-') {
			var newZoom = map.getZoom() - 1;
			map.setView({
				zoom: newZoom,
				center: location
			});
		} else if (typeof direction === 'number') {
			map.setView({
				zoom: direction,
				center: location
			});
		}
		if (_log) console.log('zoomLevel: ', getZoomLevel());
	};

	/**
	 * Get Zoom Level of map
	 */
	var getZoomLevel = function () {
		return map.getZoom();
	};


	/**
	 * Sort multi-dimensional array by a key
	 * @param arr: array of items to sort:  nameOfArray[]
	 * @param keyArr : array of keys to sort by: ['keyOne', 'keyTwo']
	 * @param reverse : boolean : true/false
	 * Usage: let tempData = this.sortArray(this.dataFake, ['Other'], true);
	 */
	var sortArray = function(arr, keyArr, reverse) {
		// console.group('sortArray()');
		// console.log('arr', arr);
		// console.log('keyArr', keyArr);
		// console.log('reverse', reverse);
		// console.groupEnd();

		var sortOrder = 1;
		if (reverse) sortOrder = -1;
		return arr.sort(function (a, b) {
			var x = a, y = b;
			for (var i = 0; i < keyArr.length; i++) {
				x = x[keyArr[i]];
				y = y[keyArr[i]];
			}
			return sortOrder * ((x < y) ? -1 : ((x > y) ? 1 : 0));
		});
	}

	/**
	 * Recalculate zoom upon init/resize
	 */
	var recalculateZoom = function () {
		if (_log) console.group('recalculateZoom()');
		if (isMobile) {
			useZoom = mobileZoom;
			useCenterLocation = mobileCenter;
			useMinZoom = mobileZoom;
			useDisableZooming = mobileDisableZooming;
		} else {
			if (isTouch) {
				useZoom = baseZoom;
				useCenterLocation = tabletLandscapeCenter;
				useMinZoom = baseZoom;
				useDisableZooming = mobileDisableZooming
			} else {
				useZoom = baseZoom;
				useCenterLocation = desktopCenter;
				useMinZoom = baseZoom;
				useDisableZooming = desktopDisableZooming
			}
		}

		if (_log) console.log('isMobile', isMobile);
		if (_log) console.log('useZoom', useZoom);
		if (_log) console.log('useCenterLocation', useCenterLocation);

		if (map != null) {
			var options = {
				zoom: useZoom,
				center: useCenterLocation,
				minZoom: useMinZoom,
				disableZooming: useDisableZooming
			}
			if (_log) console.log('options', options);
			map.setView(options);
		}
		// if (_log) console.groupEnd();

	};




	/**
	 * track resize event, update map if needed
	 */
	var trackResize = function () {
		if (_log) console.log('trackResize()');
		BingMap.Utilities.viewportDimensions();

		if (window.innerWidth < breakPoints.main) {
			isMobile = true;
		} else {
			isMobile = false;
		}

		if (wasMobile != isMobile) {
			if (_log) console.log('isMobile changed!!! update map. isMobile:', isMobile);
			wasMobile = isMobile;
			recalculateZoom();
		}
		// if (_log) console.log('wasMobile:', wasMobile);
		// if (_log) console.log('isMobile:', isMobile);
	}




	return {
		getMapInit: getMapInit,
		addPushpinCluster: addPushpinCluster,
		initializeMap: initializeMap,
		initializeButtons: initializeButtons,	
		updateReportType: updateReportType,
		getReportType: getReportType,
		togglePushpinCluster: togglePushpinCluster,
		showInfoboxByGridKey: showInfoboxByGridKey,
		showInfobox: showInfobox,
		softResetMap: softResetMap,
		pushpinClicked: pushpinClicked,
		trackResize: trackResize,
		zoomToPin: zoomToPin,
		getEpisodeData: getEpisodeData,
		getNoEpisodeData: getNoEpisodeData
	}

}();